<script setup>
import moment from "moment";
moment.locale("id");
</script>

<template>
  <DefaultLayout class="!bg-slate-50">
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-t-xl w-100 border border-1 pt-2 shadow-md h-auto overflow-hidden rounded-b-xl"
        >
          <div class="px-2 pb-2 text-[#28293d] flex items-center">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            <h4 class="font-medium">Penjadwalan Presentasi</h4>
          </div>
          <div class="bg-white rounded-t-xl w-full border p-3">
            <v-form ref="form" class="px-3">
              <div class="grid grid-cols-3 gap-3">
                <div>
                  <label
                    for="lokasikerja"
                    class="text-xs font-medium text-gray-600"
                  >
                    Tanggal Presentasi
                    <span class="text-red-700">*</span>
                  </label>
                  <v-date-input
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    :rules="formValidation.date"
                    color="#475569"
                    prepend-icon=""
                    v-model="date"
                    :min="new Date().toLocaleDateString('en-CA')"
                  >
                  </v-date-input>
                </div>

                <div class="col-span-2">
                  <label class="text-xs font-medium text-gray-600">
                    Lokasi Presentasi
                    <span class="text-red-700">*</span>
                  </label>
                  <v-text-field
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    placeholder="Masukkan lokasi"
                    color="#475569"
                    v-model="location"
                    :rules="formValidation.location"
                  >
                  </v-text-field>
                </div>
              </div>
              <div
                class="rounded-md border p-3 mt-4 relative"
                v-for="(data, index) in custodian"
                :key="index"
                v-show="data.action !== ActionEnum.DELETE"
              >
                <div class="grid grid-cols-2 gap-3">
                  <div>
                    <label class="text-xs font-medium text-gray-600">
                      Kustodian
                      <span class="text-red-700">*</span>
                    </label>
                    <v-autocomplete
                      variant="outlined"
                      color="#475569"
                      item-title="title"
                      item-value="value"
                      hide-details="auto"
                      density="compact"
                      placeholder="Pilih kustodian"
                      v-model="data.custodian"
                      return-object
                      :items="
                        custodians[index]?.map((item) => ({
                          title: `${item.name ?? ''} - ${
                            item.company ?? ''
                          } - ${item.department ?? ''} - ${
                            item.isafe_no ?? ''
                          }`,
                          value: item,
                        }))
                      "
                      :rules="formValidation.custodian"
                      @input="getCustidian(index, $event.target.value)"
                    >
                    </v-autocomplete>
                  </div>
                  <div>
                    <label class="text-xs font-medium text-gray-600">
                      Aspek Penilaian
                      <span class="text-red-700">*</span>
                    </label>
                    <v-autocomplete
                      variant="outlined"
                      color="#475569"
                      item-title="aspekPenilaian"
                      item-value="id"
                      :items="aspects"
                      hide-details="auto"
                      density="compact"
                      placeholder="Pilih aspek penilaian"
                      v-model="data.aspect"
                      :rules="formValidation.aspect"
                    >
                    </v-autocomplete>
                  </div>

                  <div
                    class="w-5 h-5 flex items-center justify-center bg-red-700 top-2 right-3 absolute rounded-full cursor-pointer"
                    @click="deleteRow(index)"
                  >
                    <img
                      src="../../assets/icon/trash.svg"
                      alt="trash"
                      class="w-3 h-auto"
                    />
                  </div>
                </div>
              </div>
              <div
                class="flex items-center gap-1 text-red-700 cursor-pointer mt-3 mb-1 w-fit"
                @click="addRow"
              >
                <font-awesome-icon
                  icon="fa-solid fa-circle-plus"
                  class="text-sm"
                />
                <h2 class="text-sm font-semibold">Tambah Kustodian</h2>
              </div>
              <div class="flex justify-end">
                <v-btn
                  :disabled="isSubmit"
                  class="bg-red-600 text-white capitalize w-1/4"
                  @click="submitData"
                >
                  Simpan
                </v-btn>
              </div>
            </v-form>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <div v-if="isLoading" class="loading-overlay">
    <div>
      <img
        src="@/assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import GlobalDataMixin from "../../GlobalDataMixin";
import axios from "axios";

import {
  API_BASE_URL,
  CMS_SET_JADWALNILAI,
  CMS_GET_JADWALNILAI,
  CMS_GET_ASPEKPENJADWALAN,
} from "@/constants";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { cloneDeep } from "lodash";
import {
  FormDataScheduleCustodian,
  FormValidasiSchedule,
} from "./core/FormData";
import { getSimperDynamic } from "@/utilities/ESBE";
import { ActionEnum } from "@/utilities/enum";
import util from "@/assets/js/util";
import { fixDate } from "@/utilities/helpers";

const url_set_jadwal = API_BASE_URL + CMS_SET_JADWALNILAI;
const url_get_aspek = API_BASE_URL + CMS_GET_ASPEKPENJADWALAN;
const url_get_jadwal = API_BASE_URL + CMS_GET_JADWALNILAI;

export default {
  mixins: [GlobalDataMixin],
  name: "PenjadwalanPresentasi",
  components: { DefaultLayout },
  data() {
    return {
      isLoading: false,
      sioID: null,
      scheduleId: null,
      custodian: [],
      date: new Date(),
      location: null,
      custodians: [],
      aspects: [],
      formValidation: FormValidasiSchedule,
      isSubmit: false,
    };
  },
  async mounted() {
    this.sioID = parseInt(this.$route.params.id);
    this.scheduleId = parseInt(this.$route.params.idpenjadwalan);
    await this.getAspect();
    if (!this.scheduleId) {
      this.addRow();
      this.getCustidian(0, null);
    } else {
      this.getSchedule();
    }
  },
  methods: {
    addRow() {
      this.custodian.push(cloneDeep(FormDataScheduleCustodian));
      this.getCustidian(this.custodian.length - 1, null);
    },
    deleteRow(index) {
      this.custodian = this.custodian.map((item, indexCusto) => ({
        ...item,
        action: index === indexCusto ? ActionEnum.DELETE : item.action,
      }));
    },
    async getCustidian(index, keyword) {
      const res = await getSimperDynamic({
        name: keyword,
        is_internal: false,
        size: 30,
      });
      this.custodians[index] = res.simper;
    },
    async getAspect() {
      const bodyJson = {
        jenis: "presentasi",
      };
      try {
        const res = await axios.post(url_get_aspek, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        this.aspects = res.data.data;
      } catch (err) {
        console.log("ERR getAspect : ", err);
        util.showError("Terjadi kesalahan saat mengambil data aspek.");
      }
    },
    async submitData() {
      if (this.isSubmit) return;

      this.isSubmit = true;
      const validate = await this.$refs.form.validate();
      const lengthCustodian = this.custodian.filter(
        (data) => data.action !== ActionEnum.DELETE,
      ).length;

      if (lengthCustodian === 0) {
        util.showError("Minimal harus ada 1 Kustodian yang ditambahkan!");
        this.isSubmit = false;
        return;
      }

      if (validate.valid) {
        const evaluation = this.custodian
          .filter((data) => data.id || (!data.id && !data.deleted))
          .map((item) => ({
            id: item.id,
            isafeNo: item.custodian.value.isafe_no,
            namaKustodian: item.custodian.value.name,
            emailKustodian: item.custodian.value.email,
            department: item.custodian.value.department,
            jabatan: item.custodian.value.position,
            company: item.custodian.value.company,
            idAspekPenilaian: item.aspect,
            action: !item.id
              ? ActionEnum.CREATE
              : item.action === ActionEnum.DELETE
              ? ActionEnum.DELETE
              : ActionEnum.UPDATE,
          }));

        if (this.hasDuplicate(evaluation)) {
          util.showError("Terdapat Kustodian dan Aspek yang duplikat!");
          return;
        }

        const payload = {
          dataPenilaian: evaluation,
          idSio: this.sioID,
          schedule: fixDate(this.date),
          lokasi: this.location,
          ...(this.scheduleId && { idPenjadwalan: this.scheduleId }),
        };

        try {
          await axios.post(url_set_jadwal, payload, {
            headers: {
              role: "isafe",
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          });

          util.showInfo("Data Penjadwalan berhasil disimpan !");

          const { type, ...filterQuery } = this.$route.query;
          const basePath =
            type === "new-coc"
              ? "/approval-sio"
              : "/pergantian-sio";
          this.$router.push({ path: basePath, query: filterQuery });
        } catch (err) {
          console.log("ERR submitData : ", err);
          util.showError("Terjadi kesalahan saat simpan data.");
        }
      }
      this.isSubmit = false;
    },
    hasDuplicate(rows) {
      const seen = new Set();

      for (const row of rows) {
        const key = `${row.isafeNo}-${row.idAspekPenilaian}`;

        if (seen.has(key)) {
          return true;
        }

        seen.add(key);
      }

      return false;
    },
    async getSchedule() {
      this.isLoading = true;
      try {
        const res = await axios.get(url_get_jadwal + this.scheduleId, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });

        const data = res.data;

        this.date = new Date(data.schedule);
        this.location = data.lokasi;
        this.custodian = data.dataPenilaian
          .filter(
            (data) =>
              data.idAspekPenilaian !== 16 &&
              data.idAspekPenilaian !== 17 &&
              data.idAspekPenilaian !== 18 &&
              data.idAspekPenilaian !== 19 &&
              data.idAspekPenilaian !== 20 &&
              data.idAspekPenilaian !== 21,
          )
          .map((item) => ({
            id: item.id,
            custodian: {
              value: {
                isafe_no: item.isafeNo,
                name: item.namaKustodian,
                email: item.emailKustodian,
                department: item.department,
                position: item.jabatan,
                company: item.company,
              },
              title: `${item.namaKustodian} - ${item.company} - ${item.department} - ${item.isafeNo}`,
            },
            aspect: item.idAspekPenilaian,
            action: null,
          }));

        this.custodians = this.custodian.map((row) => [row.custodian.value]);
      } catch (err) {
        this.isLoading = false;
        console.log("ERR getSchedule : ", err);
        util.showError("Terjadi kesalahan saat mengambil data jadwal.");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
